import styles from './AdminChecklist.module.scss'
import { ReactComponent as Check } from './check.svg'
import { ReactComponent as Cross } from './cross.svg'

const AdminChecklist = ({ list, className, x, y }) => {
  return (
    <div className={`${styles.container} ${className}`} style={{ top: y, left: x }}>
      <div className={styles.checklist}>
        {list.map(item => (
          <Item key={item.name} checked={item.checked}>
            {item.name}
          </Item>
        ))}
      </div>
    </div>
  )
}

const Item = ({ children: name, checked }) => (
  <div className={styles.item}>
    <div className={styles.itemIcon}>{checked ? <Check /> : <Cross />}</div>
    <div className={styles.itemName}>{name}</div>
  </div>
)

export default AdminChecklist
